import React, { useEffect, memo } from 'react';
import { updateWidgetProps } from '@components/common/EmpWidget/EMPWidgetContainer';
import styles from '@components/common/EmpWidget/index.less';
import { DrawerProps } from 'antd';

interface EmpBadEventDrawerProps extends DrawerProps {
  onMappedEventSuccess?: () => void;
}

const EmpBadEventDrawer: React.FC<EmpBadEventDrawerProps> = (props) => {
  useEffect(() => {
    updateWidgetProps({
      widgetName: 'BadEventDrawer',
      drawerProps: {
        rootClassName: styles.empWidgetBadEventDrawer,
        ...props,
      },
    });
  }, [props]);

  return null;
};

export default memo(EmpBadEventDrawer, (pre, next) => pre.open === next.open);
